import React,{useState, useEffect}  from 'react';
import {Card,Button} from 'react-bootstrap';
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";

function Cvariable(){



  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
     
     <Sides/>
       <Helmet>
 
 <title>C++ variable tutorial For Beginners</title>
 <meta name="description" content="C++ variable tutorial for beginners.Variable is the name of a memory location in which we can store the value, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,C++ variable tutorial for beginners,static variable in c++,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,c++ variable,c variable types,c++ variables,c++ variable arguments,c++ variable size array,c++ global variable across files,c++ variable declaration rules,cpp variable cannot start with,c++ extern variable example" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-variable" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C++ Variable</h1>
    <div className="first">
       
        <a href="/cpp-scope-of-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para ">
    1, Variable is the name of a memory location in which we can store the value<br/>
    2, C++ can change variable values easily<br/>
    3, A variable is defined by combining an identifier, data types, and an initializer.<br/>
    4, The first character in the variable name must be an alphabet, underscore, a digit, or a dollar sign. <br/>
    5, All variables have a scope<br/>
    6, The identifier is the name of the Variable<br/>
    7, Commas or blanks are not using inside a variable name

    </p>
   

<h2 className="headings">C++ variable declaration syntax:</h2>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}
              <span className="qwerty-10">type</span>
              <span className="qwerty-4"> Variable name</span>
            
              <span className="qwerty-3"> ;</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-4">int </span>
              <span className="qwerty-5">is a </span>
              <span className="qwerty-10">type </span>
              {"\n"}
              {"\n"}
              <span className="qwerty-10">a, b and ab are a</span>
            
              <span className="qwerty-5"> Variable name</span>
             
              {"\n"}
           
            
           </code>{"\n"}</pre>
        </div>








<h2 className='headings'>C++ Variable Declaration syntax Examples</h2>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
          <pre className="python-exec" style={{maxHeight: '600px'}}>
          <code className="python hljs">{"\n"}
          <span className="qwerty-10">type </span> 
          <span className="qwerty-4">variable name: </span> 
          {"\n"}
          <span className="qwerty-10">int </span>
          <span className="qwerty-4">roll_no; </span>
          <span className="qwerty"> &#47;&#47; This declare a variable</span>
          {"\n"}

          

          <span className="qwerty-10">float</span>
          <span className="qwerty-4"> percentage; </span>
          <span className="qwerty"> &#47;&#47; This declare a variable</span>
          {"\n"}


          <span className="qwerty-4">roll_no =</span> 
          <span className="qwerty-7">40;</span>   
          
          
          <span className="qwerty"> &#47;&#47; Assigns a variable a value</span> 
          {"\n"}
          <span className="qwerty-4">Percentage = </span>
          <span className="qwerty-7">40.80;</span>
          

          <span className="qwerty"> &#47;&#47; Assigns a variable a value</span>
           {"\n"}{""}</code>{"\n"}{"     "}</pre>
        </div>




{/* K */}



<h2 className='headings'>Declare variable in C++ Rules</h2>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
          <pre  style={{ maxHeight: '500vh'  }}>
            <code className="python hljs">{"\n"}
              <span className="qwerty">int </span>
              <span className="qwerty-2"> abc ;</span>
              <span className="qwerty-3"> &#47;&#47;this declare a</span>
              <span className="qwerty-9"> variable</span>
              {"\n"}{"\n"}
              <span className="qwerty">int </span>
              <span className="qwerty-10"> abc ;</span>
              <span className="qwerty-3"> &#47;&#47; (abc and a_bc are a) </span>
              <span className="qwerty-9">variable</span>
              {"\n"}{"\n"}
              <span className="qwerty">int </span>
              <span className="qwerty-2"> a,b,x,z;</span>
              <span className="qwerty-3">  &#47;&#47;(a,b,x,z) are a</span>
              <span className="qwerty-9"> variable</span>
              {"\n"}{"\n"}
              <span className="qwerty">byte </span>
              <span className="qwerty-10">a1</span>
              <span className="qwerty-1"> = </span>
              <span className="qwerty-5">40;</span>
              <span className="qwerty-3"> &#47;&#47; </span>
              <span className="qwerty-7"> initialize </span>
              <span className="qwerty-8">a.</span>
              {"\n"}{"\n"}
              <span className="qwerty">double</span>
              <span className="qwerty-2"> a2</span>
              <span className="qwerty-1"> = </span>
              <span className="qwerty-5">40.80;</span>
              <span className="qwerty-3"> &#47;&#47; like a</span>
              <span className="qwerty-7">  float</span>
              {"\n"}{"\n"}
              <span className="qwerty">char </span>
              <span className="qwerty-10"> a3 </span>
              <span className="qwerty-1"> = </span>
              <span className="qwerty-5"> “ram”; </span>
              <span className="qwerty-3">&#47;&#47; </span>
              <span className="qwerty-7">a3 </span>
              <span className="qwerty-3">variable gain value </span>
              <span className="qwerty-10"> ( ram )</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div>

{/* gb */}









<h2 className="mt-4 mh2">Declare a variable in C++:</h2>
<p className="mt-4 para">C++ Variable declare in various types.</p>



<h2 className="mt-4 mh2">Addition of Variables Examples:</h2>


<h2 className='headings'>Q-Write a program to Add Variables in C++?</h2>
                <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
                    <pre  style={{ maxHeight: '500vh' }}>
                        <code className="python hljs">{"\n"}
                            <span className="qwerty-7">#include </span>
                            <span className="qwerty-3">&#60;</span>
                            <span className="qwerty-9">iostream</span>
                            <span className="qwerty-3">&#62; </span>
                            {"\n"}{"\n"}
                            <span className="qwerty-2">using </span>
                            <span className="qwerty-9">namespace </span>
                            <span className="qwerty-2">std; </span>
                            {"\n"}{"\n"}
                            <span className="qwerty-7">int </span>
                            <span className="qwerty-5">main</span>
                            <span className="qwerty-3"> ()</span>
                            {"\n"}{"\n"}{" "}
                            <span className="qwerty-3"> &#123; </span>
                            {"\n"}{"\n"}{"  "}
                            <span className="qwerty-7">int</span>
                            <span className="qwerty-2"> a,b,c,d;</span>
                            {"\n"}{"\n"}{"  "}
                            <span className="qwerty-7">a </span>
                            <span className="qwerty-1">= </span>
                            <span className="qwerty-10">10; </span>
                            <span className="qwerty-7">b </span>
                            <span className="qwerty-1">= </span>
                            <span className="qwerty-10">20; </span>
                            <span className="qwerty-7">c</span>
                            <span className="qwerty-1"> =</span>
                            <span className="qwerty-10"> 30;</span>
                            <span className="qwerty-7"> d</span>
                            <span className="qwerty-1"> =</span>
                            <span className="qwerty-10"> 40;</span>
                            {"\n"}{"\n"}{"  "}
                            <span className="qwerty-7">cout </span>
                            <span className="qwerty-1">&#60;&#60;</span>
                            <span className="qwerty-10"> a+b+c+d; </span>
                            {"\n"}{"\n"}{"  "}
                            <span className="qwerty-7">return </span>
                            <span className="qwerty-10">0; </span>
                            {"\n"}{"\n"}{"   "}
                            <span className="qwerty-3">&#125; </span>
                            {"\n"}{"\n"}
                            
                          
                        </code>
                    </pre>
                </div>

                <h3 className="headings">Output</h3>
      
      <div style={{background: '#0f0e33', width:'94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
        <pre className="python-exec" style={{maxHeight: '600px'}}><code className="python hljs">{"\n"}<span className="qwerty-3">100</span> {"\n"}{"   "}</code></pre>
      </div>





<h2 className='headings'>Q-Write a program variable increment in C?</h2>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
          <pre style={{ maxHeight: '500vh'  }}>
            <code className="python hljs">{"\n"}
              <span className="qwerty-7">#include </span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-4">iostream</span>
              <span className="qwerty-3">&#62; </span>
              {"\n"}{"\n"}
              <span className="qwerty-2">using </span>
              <span className="qwerty-4">namespace </span>
              <span className="qwerty-2">std; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-7">int </span>
              <span className="qwerty-5">main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}{"\n"}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-7">int </span>
              <span className="qwerty-10">a </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9">10; </span>
              {"\n"}{"\n"}{"     "}
              <span className="qwerty-10">a</span>
              <span className="qwerty-3">+</span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9">40; </span>
              {"\n"}{"\n"}{"     "}
              <span className="qwerty-10">a</span>
              <span className="qwerty-1"> =</span>
              <span className="qwerty-10"> a</span>
              <span className="qwerty-3"> +</span>
              <span className="qwerty-9"> 20;</span>
              {"\n"}{"\n"}{"  "} 
              <span className="qwerty-7">cout </span>
              <span className="qwerty-1">&#60;&#60;</span>
              <span className="qwerty-10"> a; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-7"> return </span>
              <span className="qwerty-9">0; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-3">&#125; </span>
            
              {"\n"} {"\n"}
            </code>
          </pre>
        </div>

        <h3 className="headings">Output</h3>
      
      <div style={{background: '#0f0e33', width:'94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
        <pre className="python-exec" style={{maxHeight: '600px'}}><code className="python hljs">{"\n"}<span className="qwerty-3">70</span> {"\n"}{"\n"}</code></pre>
      </div>



<h2 className='head3'>Q-Write a program to create a variable store a no inside this Variable and print output in C?</h2>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
          <pre style={{ maxHeight: '500vh'  }}>
            <code className="python hljs">{"\n"}
              <span className="qwerty-7">#include </span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-5">iostream</span>
              <span className="qwerty-3">&#62; </span>
              {"\n"}{"\n"}
              <span className="qwerty-2">using </span>
              <span className="qwerty-5">namespace </span>
              <span className="qwerty-2">std; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-7">int </span>
              <span className="qwerty-5">main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}{"\n"}{"       "}
              
              <span className="qwerty-7">int </span>
              <span className="qwerty-10">a;</span>
              {"\n"}{"\n"}{"       "}
              <span className="qwerty-10">a </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9">40; </span>
              {"\n"}{"\n"}{"        "}
              
              <span className="qwerty-2"> OR</span>
              {"\n"}{"\n"}{"       "}
      
             
              <span className="qwerty-7">int </span>
              <span className="qwerty-10">a </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9">40; </span>
              {"\n"}{"\n"}{"       "}
              <span className="qwerty-7">cout </span>
              <span className="qwerty-1">&#60;&#60;</span>
              <span className="qwerty-10"> a; </span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-7"> return </span>
              <span className="qwerty-9">0; </span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-3">&#125; </span>
          
              {"\n"}{"\n"}{"    "}
            </code>
          </pre>
        </div>

        <h3 className="headings">Output</h3>
      
      <div style={{background: '#0f0e33', width:'94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
        <pre className="python-exec" style={{maxHeight: '600px'}}><code className="python hljs">{"\n"}<span className="qwerty-3">40</span> {"\n"}{"\n"}</code></pre>
      </div>


<p className="mt-4 para">1, String is a sequence of characters and closed in " ".<br/>
2, String is the name of a memory location in which we can store the Text<br/>
3, C++ can change the Text of String<br/>
4, Text or character enclosed by double quotes<br/>
</p>

<h2 className="mt-4 mh2">Create Variable String Type: </h2>




<h2 className='head3'>Q-Write a program to create a string variable and store a no inside string type variable and print output in C?</h2>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
          <pre  style={{ maxHeight: '500vh'  }}>
            <code className="python hljs">{"\n"}
              <span className="qwerty-7">#include </span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-5">iostream</span>
              <span className="qwerty-3">&#62; </span>
              {"\n"}{"\n"}
              <span className="qwerty-2">using </span>
              <span className="qwerty-5">namespace </span>
              <span className="qwerty-2">std; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-7">int </span>
              <span className="qwerty-5">main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}{"\n"}{"        "}
              <span className="qwerty-7">string </span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-1"> =</span>
              <span className="qwerty-9">"Ram";</span>
              {"\n"}{"\n"}{"        "}
              <span className="qwerty-7">string </span>
              <span className="qwerty-10">b</span>
              <span className="qwerty-1"> =</span>
              <span className="qwerty-9">"Lakshman";</span>
              {"\n"}{"\n"}{"        "}

              <span className="qwerty-2"> OR</span>

              {"\n"}{"\n"}{"        "}
              <span className="qwerty-7">string </span>
              <span className="qwerty-10">a,b; </span>
              {"\n"}{"\n"}{"        "}
              <span className="qwerty-10">a </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9">"Ram"; </span>
              {"\n"}{"\n"}{"        "}
              <span className="qwerty-10">b </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9"> "Lakshman";</span>
              {"\n"}{"\n"}{"    "}
              <span className="qwerty-7">cout </span>
              <span className="qwerty-1">&#60;&#60;</span>
              <span className="qwerty-10"> a+" "+b; </span>
              {"\n"}{"\n"}{"  "}
              <span className="qwerty-7"> return </span>
              <span className="qwerty-9">0; </span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-3">&#125; </span>
              {"\n"}{"\n"}
              
     
            </code>
          </pre>
        </div>

        <div style={{background: '#0f0e33', width:'94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
        <pre  style={{maxHeight: '600px'}}><code className="python hljs">{"\n"}<span className="qwerty-3">Ram Lakshman</span> {"\n"}{"\n"}</code></pre>
      </div>

<h2 className="mt-4 mh2"> Another string type example</h2>



<h2 className='headings'>Q-Write a program to create a string variable and store a no inside string data type variable and print output?</h2>
        <div style={{background: '#0f0e33', width: '95%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
          <pre className="python-exec" style={{ maxHeight: '600px' }}>{"  "}
            <code className="python hljs">{"\n"}{""}
              <span className="qwerty-7">#include </span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-5">iostream</span>
              <span className="qwerty-3">&#62; </span>
              {"\n"}{"\n"}{""}
              <span className="qwerty-2">using </span>
              <span className="qwerty-5">namespace </span>
              <span className="qwerty-2">std; </span>
              {"\n"}{"\n"}{""}
              <span className="qwerty-7">int </span>
              <span className="qwerty-5">main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}{"\n"}{""}
              <span className="qwerty-3"> &#123; </span>
              {"\n"}{"\n"}{" "}
              <span className="qwerty-7">string </span>
              <span className="qwerty-10">a,b,c;</span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-10">a </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9">"Ram"; </span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-10">b </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9"> "Lakshman";</span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-10">c </span>
              <span className="qwerty-1">= </span>
              <span className="qwerty-9"> "My Name is CodeExampler 160208";</span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-7">cout </span>
              <span className="qwerty-1">&#60;&#60;</span>
              <span className="qwerty-10">  a+" "+b+" "+c; </span>
              {"\n"}{"\n"}{"   "}
              <span className="qwerty-7">return </span>
              <span className="qwerty-9">0; </span>
              {"\n"}{"\n"}{""}
              <span className="qwerty-3">&#125; </span>
              {"\n"}{"\n"}{"        "}
              
             
            </code>
          </pre>
        </div>

        <div className="Questions">
          <h3 className="headings">Output</h3>
        </div>
        
        <div style={{background: '#0f0e33', width:'94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px'}}>
          <pre className="python-exec" style={{maxHeight: '600px'}}><code className="python hljs"> {"\n"}{" "}<span className="qwerty-3">Ram Lakshman My Name is CodeExampler 160208</span> {"\n"}{"   "}</code></pre>
        </div>



<h2 className="mt-4 mh2">Constant:</h2>

<p className="mt-4 para">Constant is used when you store a value inside a variable, but after you can’t overwrite the current value, so on that place use constant.
</p>
<h1 className="mt-5">  </h1>



<div className="back">
       
        <a href="/cpp-scope-of-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Cvariable;